<template>
  <span>
    <b-button
      rounded
      @click="onCopy"
      type="is-primary"
      outlined
    >Copy to Clipboard</b-button>
    <transition name="fade">
      <span
        v-if="showHintText"
        class="hint-text"
      >Copied!</span>
    </transition>
  </span>
</template>

<script>
export default {
  name: 'HelpModal',
  props: ['selector'],
  data () {
    return {
      showHintText: false,
    }
  },
  methods: {
    onCopy: function () {
      const range = document.createRange();
      range.selectNode(document.querySelector(this.selector));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      this.showHintText = true;
      setTimeout(() => this.showHintText = false, 2000);
    }
  }
}
</script>

<style scoped>
.copy-button {
  display: inline;
}

.hint-text {
  display: inline-block;
  margin: 5px 10px;
}
</style>